import { Component } from '@angular/core';
import { RouterLinkActive, RouterLink } from '@angular/router';

@Component({
    selector: 'app-file-check-nav',
    templateUrl: './file-check-nav.component.html',
    styleUrls: ['./file-check-nav.component.scss'],
    imports: [RouterLinkActive, RouterLink]
})
export class FileCheckNavComponent {
  constructor() {}
}
